import React, { createContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import ModalDialog from '../../components/ModalDialog';

const ModalContext = createContext();

const initialState = { show: false };

const ModalProvider = ({ children }) => {
  const [data, setData] = useState(initialState);

  // HandleCleanup will take care of clearing modal data after the fadeout animation
  // ended. This is needed otherwise if we reset modal data when show is set false,
  // we will see a glitch during transition out animation.
  const handleCleanup = useCallback(() => setData(initialState), []);

  return (
    <ModalContext.Provider
      value={{
        show: data.show,
        data,
        setData,
      }}
    >
      <>
        <ModalDialog {...data} handleCleanup={handleCleanup} />
        {children}
      </>
    </ModalContext.Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ModalContext, ModalProvider };
